module.exports = __webpack_public_path__ + "e07248992db221994eec88ca09b0b820.fbx";